import { render } from "./CustomSelect.vue?vue&type=template&id=188b4606&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=188b4606&scoped=true&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188b4606"]])

export default __exports__